/**
 * @description 集群管理 clusterManager
 * @author 系统生成
 * @date 2018/9/20
 */

import Logic from '../logic-base'

const clusterManagerBiz = new Logic()

clusterManagerBiz.addMachine = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.clusterManager.addMachine,
    data: data
  })
}

clusterManagerBiz.deleteCluster = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.clusterManager.deleteCluster,
    data: data
  })
}

clusterManagerBiz.deleteSingerCluster = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.clusterManager.deleteSingerCluster,
    data: data
  })
}

clusterManagerBiz.getCluster = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.clusterManager.getCluster,
    data: data
  })
}

clusterManagerBiz.getSingerCluster = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.clusterManager.getSingerCluster,
    data: data
  })
}

clusterManagerBiz.getSingerClusterMachine = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.clusterManager.getSingerClusterMachine,
    data: data
  })
}

clusterManagerBiz.saveCluster = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.clusterManager.saveCluster,
    data: data
  })
}

clusterManagerBiz.updateCluster = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.clusterManager.updateCluster,
    data: data
  })
}

clusterManagerBiz.newUpdateCluster = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.clusterManager.newUpdateCluster,
    data: data
  })
}

export default clusterManagerBiz
